<template>
  <div class="payment-methods">
    <h3 class="heading">Accepted payment methods</h3>

    <div class="payment-method-icons">
      <img
        v-for="(icon, methodName) in paymentMethodIcons"
        :key="methodName"
        :src="icon"
        :style="{ width: methodName === 'klarna' && '43px' }"
      />
    </div>

    <div class="bnpl">
      <BNPLInformation :price="subtotal" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BNPLInformation from "@/components/product-display/BNPLInformation.vue";
import { paymentMethods } from "@/config.js";

export default {
  name: "PaymentMethods",
  components: {
    BNPLInformation,
  },
  computed: {
    ...mapGetters("cart", ["subtotal"]),
    ...mapGetters("app", ["currencyCode"]),
    paymentMethodIcons() {
      return {
        visa: require("@/assets/images/payment-methods/visa.svg"),
        mastercard: require("@/assets/images/payment-methods/mastercard.svg"),
        maestro: require("@/assets/images/payment-methods/maestro.svg"),
        amex: require("@/assets/images/payment-methods/amex.svg"),
        paypal: require("@/assets/images/payment-methods/paypal.svg"),
        klarna: this.showKlarna
          ? require("@/assets/images/payment-methods/klarna.svg")
          : null,
      };
    },
    showKlarna() {
      const klarnaEnabled = paymentMethods[this.currencyCode]?.klarnaEnabled;
      const clearpayEnabled =
        paymentMethods[this.currencyCode]?.clearpayEnabled;

      // Show Klarna if both Klarna and Clearpay are enabled
      return klarnaEnabled && clearpayEnabled;
    },
  },
};
</script>

<style lang="scss" scoped>
.payment-methods {
  padding: 20px 0 0;
}

.payment-method-icons {
  display: flex;
  align-items: center;
  gap: 15px;
}

.bnpl {
  margin-top: 10px;

  &:deep(.provider) {
    text-align: left;
    justify-content: left;
    @include t__utility-body-10;
  }
}

.heading {
  @include t__utility-label-30;
  margin-bottom: 10px;
}
</style>
